// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import AppTabController from "../../services/app-tab-controller";
function InstructionLinkedItems(instructionVM, tabPage) {
    var self = this;
    self.TabPage = tabPage;
    self.InstructionVM = instructionVM;
    self.InstructionId = self.InstructionVM.InstructionId;
    self.SessionTabId = self.InstructionVM.SessionTabId;
    self.Models = ko.observableArray([]);
    self.Sorting = ko.observableArray([]);
    self.Selection = ko.observableArray([]);
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.SelectedLinkedItem = ko.observableArray([]);
    self.SelectedSearchDialogItemToLink = ko.observable();
    self.ToolbarBtns = ko.observableArray();
    self.ToolTip = ko.observable("");
    self.OriginalTabTitle = self.TabPage.Title();
    self.TotalRows.subscribe(function (value) {
        if (value == null || value == 0) {
            self.TabPage.Title(self.OriginalTabTitle);
            return;
        }
        self.TabPage.Title(self.OriginalTabTitle + " (" + value + ")");
    });
    self.TabPage.IconLeft("fal fa-link");
    self.ToolbarBtns.subscribe(function () {
        self.toggleToolbarButton();
    });
    self.SelectedSearchDialogItemToLink.subscribe(function (data) {
        self.LinkItem(ko.unwrap(ko.unwrap(data).Id));
    });
    self.SelectedLinkedItem.subscribe(function () {
        self.toggleToolbarButton();
    });
    Bao.bindEvent('linked-item:refreshToolbarButton', () => {
        self.toggleToolbarButton()
    });
    Bao.bindEvent('linked-item:refreshGrid', () => {
        self.refreshGrid()
    });
    self.toggleToolbarButton = function () {
        var refreshAllowed = true;
        var addItems = true;
        var remItem = true;
        if (ko.unwrap(ko.unwrap(self.InstructionVM).SaveAllowed) !== true) {
            addItems = remItem = refreshAllowed = false;
        }
        else {
            if (ko.unwrap(self.SelectedLinkedItem) == false || ko.unwrap(self.SelectedLinkedItem).length == 0) {
                remItem = false;
            }
        }
        if (ko.unwrap(ko.unwrap(self.InstructionVM).IsNew) === true) {
            refreshAllowed = false;
        }
        if (ko.unwrap(ko.unwrap(self.InstructionVM).IsHistory) === true) {
            addItems = remItem = refreshAllowed = false;
        }
        ko.utils.arrayForEach(self.ToolbarBtns(), function (item: any) {
            if (item.ActionKey() == "ChainedItemsNewInstruction" || item.ActionKey() == "ChainedItemsNewTask" || item.ActionKey() == "ChainedItemsLinkObject") {
                item.Enabled(addItems);
            }
            else if (item.ActionKey() == "ChainedItemsUnlinkItem") {
                item.Enabled(remItem);
            }
            else if (item.ActionKey() == "ChainedItemsRefresh") {
                item.Enabled(refreshAllowed);
            }
        });
    };
    self.toolbarButtonClicked = function (btn) {
        var actionKey = ko.unwrap(btn.ActionKey);
        switch (actionKey) {
            case "ChainedItemsNewInstruction":
                self.CreateNewInstruction();
                break;
            case "ChainedItemsNewTask":
                self.CreateNewTask();
                break;
            case "ChainedItemsLinkObject":
                self.LinkExistingItem();
                break;
            case "ChainedItemsUnlinkItem":
                self.UnlinkItem();
                break;
            case "ChainedItemsRefresh":
                self.Refresh();
                break;
        }
    };
    self.CreateNewTask = function () {
        var newTab = new TabPage();
        newTab.Url("Task/index");
        newTab.UrlData({
            id: null,
            linkFn: self.LinkItem.bind(self)
        });
        AppTabController.AddTab(newTab);
    };
    self.CreateNewInstruction = function () {
        var newTab = new TabPage();
        newTab.Url("Instruction/index");
        newTab.UrlData({
            id: null,
            linkFn: self.LinkItem.bind(self)
        });
        AppTabController.AddTab(newTab);
    };
    self.LinkExistingItem = function () {
        self.showLinkInfoSearchDialog();
    };
    self.LinkItem = function (linkedItemId) {
        self.TabPage.IsLoading(true);
        return Bao.post("InstructionLinkedItems/LinkItem", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InstructionVM).SessionTabId),
            linkedItemId: ko.unwrap(linkedItemId)
        })).then(function () {
            self.TabPage.DirtyFlag(true);
            return self.refreshGrid();
        }).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.UnlinkItem = function () {
        var item = ko.unwrap(self.SelectedLinkedItem);
        if (item == false || !(item.length > 0)) {
            return;
        }
        self.TabPage.IsLoading(true);
        return Bao.post("InstructionLinkedItems/UnlinkItem", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InstructionVM).SessionTabId),
            linkedItemId: ko.unwrap(item[0].Id)
        })).then(function () {
            self.TabPage.DirtyFlag(true);
            return self.refreshGrid();
        }).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.ResetSessionTabId = function () {
        self.TabPage.IsLoading(true);
        return Bao.post("InstructionLinkedItems/ResetLinkedItems", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InstructionVM).SessionTabId)
        })).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.shouldSave = function () {
        var deferred = $.Deferred();
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), "question");
        dialog.DialogResult.subscribe(function (saveInformation) {
            deferred.resolve(saveInformation);
        });
        return deferred.promise();
    };
    self.Save = function () {
        self.TabPage.IsLoading(true);
        return Bao.post("InstructionLinkedItems/SaveLinkedItems", JSON.stringify({
            instructionId: ko.unwrap(ko.unwrap(self.InstructionVM).InstructionId),
            sessionTabId: ko.unwrap(ko.unwrap(self.InstructionVM).SessionTabId)
        })).always(function () {
            self.TabPage.DirtyFlag(false);
            self.TabPage.IsLoading(false);
        });
    };
    self.showLinkInfoSearchDialog = function () { };
    self.refreshGrid = function () {
        return Bao.post("InstructionLinkedItems/GetAllLinkedItems", JSON.stringify({
            sessionTabId: ko.unwrap(self.SessionTabId),
            instructionId: ko.unwrap(self.InstructionId),
            pageIndex: ko.unwrap(self.PageIndex),
            pageSize: ko.unwrap(self.PageSize),
            sorter: ko.unwrap(self.Sorting)
        })).done(function (data) {
            self.TotalRows(data.total);
            ko.map.fromJS(data.data, self.Models);
        });
    };

    self.Refresh = function () {
        var def;
        if (self.TabPage.DirtyFlag() && ko.unwrap(ko.unwrap(self.InstructionVM).SaveAllowed) === true) {
            def = self.shouldSave();
        }
        else {
            def = $.Deferred().resolve(false);
        }
        return def.then(function (shouldSave) {
            if (shouldSave === true) {
                return self.Save();
            }
            else if (shouldSave === null) {
                return $.Deferred().reject();
            }
            return true;
        }).then(function () {
            self.TabPage.IsLoading(true);
            return self.ResetSessionTabId().then(self.refreshGrid).done(function () {
                self.TabPage.DirtyFlag(false);
                self.TabPage.IsLoading(false);
            });
        });
    };
    ko.unwrap(self.InstructionVM).SubTabsSaveFn.push(self.Save);
    self.init = function () {
        self.TabPage.IsLoading(true);
        return self.ResetSessionTabId()
            .then(_ => self.refreshGrid());
    };
    self.loaded = function () {
        self.TabPage.IsLoading(false);
        self.Sorting.subscribe(function () {
            self.refreshGrid();
        });
        self.PageIndex.subscribe(function () {
            self.refreshGrid();
        });
        self.TabPage.DirtyFlag.subscribe(function () {
            if (ko.unwrap(self.TabPage.DirtyFlag)) {
                ko.unwrap(self.InstructionVM).TabPage.DirtyFlag(true);
            }
        });
    };
    self.SetPermissions = function () {
        self.InstructionVM.SetPermissions(self.boaToolbar2ShowButton);
    };
    self.boaToolbar2ShowButton;
}
export default InstructionLinkedItems;